//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import PublicService from '@/service/public'
import CommonTabs from '@/components/views/common_tabs'
import ArticleItem from '@/components/views/common_article'

const TYPE = {
    MEDIA: 'building_feeds',
    WEIXIN: 'weixin_articles'
}

const MEDIA = {
    key: TYPE.MEDIA,
    name: '自媒体文章'
}

const WEIXIN = {
    key: TYPE.WEIXIN,
    name: '楼盘公众号'
}

const TABS = [
    MEDIA,
    WEIXIN
]

export default {
    data () {
        return {
            building_feeds: [],
            weixin_articles: [],
            tabs: TABS,
            selected_type: TYPE.MEDIA,
            show: false
        }
    },
    computed: {
        items () {
            return this[this.selected_type]
        }
    },
    methods: {
        getData (building_id, weixin_account_id) {
            return Service.getArticle(building_id, weixin_account_id).then(({ media, weixin }) => {
                this.building_feeds = this.has_more ? media.slice(0, 2) : media
                this.weixin_articles = this.has_more ? weixin.slice(0, 2) : weixin
                const tabs = []
                if (media.length) {
                    tabs.push(MEDIA)
                }
                if (weixin.length) {
                    tabs.push(WEIXIN)
                }
                this.tabs = tabs
                this.selected_type = media.length ? TYPE.MEDIA : TYPE.WEIXIN
                this.show = media.length || weixin.length
                return this.show
            })
        },
        changeType (type) {
            this.selected_type = type
        },
        goMore () {
            this.$emit('goMore')
        },
        onLike (id, liked, success) {
            let type = 'Fc::WeixinArticle'
            if (this.selected_type === TYPE.MEDIA) {
                type = 'Fc::BuildingFeed'
            }
            PublicService.like(type, id, liked).then(success)
        }
    },
    components: {
        ArticleItem,
        CommonTabs
    },
    props: {
        has_more: {
            type: Boolean,
            default: false
        }
    }
}
